import React from "react";
import Routes from "./routes/Routes";
import AuthBootstrap from "./store/AuthBootstrap";
import { TransaksiProvider } from "./context/transaksiContext";
import { QueryClientProvider } from "react-query";
import { queryClient } from "./config/queryClient";
import "./App.css";

const ReactQueryDevtools =
    process.env.NODE_ENV === "development"
        ? React.lazy(() =>
              import("react-query/devtools").then((module) => ({
                  default: module.ReactQueryDevtools,
              })),
          )
        : null;

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <AuthBootstrap>
                <TransaksiProvider>
                    <Routes />
                </TransaksiProvider>
            </AuthBootstrap>
            {ReactQueryDevtools && (
                <React.Suspense fallback={null}>
                    <ReactQueryDevtools
                        initialIsOpen={false}
                        position="bottom-right"
                    />
                </React.Suspense>
            )}
        </QueryClientProvider>
    );
}

export default App;
